import React from 'react';
import { createRoot } from 'react-dom/client';

import "~/scss/pages/demo_index_page.scss";

import DemoIndexApp from "./containers/DemoIndexApp";

createRoot(document.getElementById("demo-index-app")).render(<DemoIndexApp demos = { DEMOS } />);